import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { PositiveIntegerOnly } from '../../../../directives/positive-integer-only';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
	selector: 'app-integer-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzInputModule, PositiveIntegerOnly],
	templateUrl: './integer-control.html',
	styleUrl: './integer-control.scss',
})
export class IntegerControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	disabled = input<boolean>(false);
	labelSpan = input<number>(7);
	controlSpan = input<number>(12);
	min = input<number | null>(null);
	max = input<number | null>(null);
	formGroup = input.required<FormGroup>();
}
